import { Button, Tag } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/auth.slice";
import CreateGroupExpenseModal from "../CreateGroupExpenseModal";
import GroupListScreen from "../GroupListScreen";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupExpenses } from "../../../services/groupConsole.service";

const GroupExpenses = () => {
  const user = useSelector(selectUser);
  const branches = useGroupBranchOptions();
  const [showCreate, setShowCreate] = useState(false);

  return (
    <>
      <GroupListScreen
        title="Expenses"
        queryKey="group-console-expenses"
        fetchFn={fetchGroupExpenses}
        searchPlaceholder="Search by name or category"
        branchOptions={branches.options}
        branchOptionsLoading={branches.isLoading}
        extraHeader={
          <Button type="primary" onClick={() => setShowCreate(true)}>
            Create Expense
          </Button>
        }
        columns={[
          { title: "Name", dataIndex: "name" },
          { title: "Category", dataIndex: "category", align: "center" },
          {
            title: "Amount",
            dataIndex: "amount",
            align: "center",
            render: (amount) => `₹${(amount ?? 0).toLocaleString("en-IN")}`,
          },
          {
            title: "Status",
            dataIndex: "status",
            align: "center",
            render: (status) => <Tag>{status || "—"}</Tag>,
          },
        ]}
      />
      <CreateGroupExpenseModal
        groupId={user?.group}
        open={showCreate}
        onClose={() => setShowCreate(false)}
      />
    </>
  );
};

export default GroupExpenses;
